import {Component, OnInit} from '@angular/core';
import {AmplifyService} from 'aws-amplify-angular';
import {LanguageService} from '../shared/language.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.css']
})
export class LanguageSelectorComponent implements OnInit {
  private languageService: LanguageService;
  private amplifyService: AmplifyService;
  private message: String;

  constructor(amplifyService: AmplifyService, languageService: LanguageService) {
    this.languageService = languageService;
    this.amplifyService = amplifyService;
  }

  onClick(language: String) {
    this.languageService.setLanguage(language);
  }

  ngOnInit() {
    this.message = 'copyright ©2021 Vom Marketal';
  }

}
